import type {Elements, IContentItem} from '@kontent-ai/delivery-sdk'
import {clsx} from 'clsx'
import {Button as CButton} from '@/products/flexible-web-toolkit/components/button/button'
import type {Block} from '@/services/kontent-ai/types'
import {pushToDataLayer} from '@/utilities/analytics'
import {logEvent} from '@/services/logger/client'
import {colorWithFallback} from '@/utilities/hooks/color-with-fallback'
import {spacing} from '../../flexible-web-toolkit/styles'

type MikmakProductIdContentItem = IContentItem<{
	dataEan: Elements.TextElement
}>

export type MikmakButtonContentItem = IContentItem<{
	text: Elements.TextElement
	variant: Elements.MultipleChoiceElement
	productIds: Elements.LinkedItemsElement<MikmakProductIdContentItem>
	snippetSpacingSpacing: Elements.MultipleChoiceElement
	wtbId: Elements.TextElement
	/** New custom element color picker – preferred source for button color */
	brandColor: Elements.CustomElement
	hideMikmakBuyNowButton: Elements.MultipleChoiceElement
}>

export const MikMakButtonBlock: Block<MikmakButtonContentItem> = ({
	block,
	page,
}) => {
	const {colorId} = colorWithFallback({
		blockColor: block.elements.brandColor, // new color
		blockColorLegacy: block.elements.variant, // old color (multiple choice)
		pageConfig: page.elements.config[0], // new color from page config
		fallbackColorId: 'primary', // old logic
	})

	const hideMikmakBuyNowButton =
		block.elements.hideMikmakBuyNowButton[0]?.codename === 'yes'

	const spacingChoice =
		spacing[
			block.elements.snippetSpacingSpacing[0]
				?.codename as keyof typeof spacing
		]
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- not unnecessary, spacingChoice may be null
	const componentSpacing = spacingChoice ?? spacing.default

	const handleOnClick = (): void => {
		pushToDataLayer({
			event: 'cta_click',
			cta_name: block.elements.text,
			cta_category: 'CTA_Button',
		})

		logEvent({
			name: 'MIKMAK_BUTTON_CLICK',
			properties: {
				cta_name: block.elements.text,
				product_ids: block.elements.productIds
					.map((id) => id.elements.dataEan.trim())
					.join(','),
			},
		})
	}
	return (
		<div
			className={clsx(`text-center`, componentSpacing)}
			data-kontent-element-codename={block.system.codename}
		>
			{hideMikmakBuyNowButton ? (
				<CButton
					className="swn-tag-wtb-btn sr-only mt-2"
					data-eans={block.elements.productIds
						.map((id) => id.elements.dataEan.trim())
						.join(',')}
					data-mm-sticky
					data-mm-wtbid={block.elements.wtbId}
					onClick={handleOnClick}
					variant={colorId}
				>
					{block.elements.text}
				</CButton>
			) : (
				<CButton
					className="swn-tag-wtb-btn mt-2"
					data-eans={block.elements.productIds
						.map((id) => id.elements.dataEan.trim())
						.join(',')}
					data-mm-sticky
					data-mm-wtbid={block.elements.wtbId}
					onClick={handleOnClick}
					variant={colorId}
				>
					{block.elements.text}
				</CButton>
			)}
		</div>
	)
}
